module.exports = {"domain":"dev-pxqcewc8ao1p8nga.us.auth0.com","clientId":"AqypBvYLiULBYClNJgH90qHTON8qgkAF","authorizationParams":{"audience":"https://dev-pxqcewc8ao1p8nga.us.auth0.com/api/v2/"}}


//////////////////
// WEBPACK FOOTER
// ./auth_config.json
// module id = kMb3
// module chunks = 1